import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import { motion } from 'framer-motion';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { useAuth } from '../../Utils/Auth';
import './index.css';
import AccountsService from '../../Services/AccountsService';
import { useAuth } from '../../Utils/Auth';
import { toTitleCase } from '../../Utils/helper';

const IntroducerLogin = () => {
    const [credentials, setCredentials] = useState({
        username: '',
        password: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const auth = useAuth();
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setCredentials(prev => ({
            ...prev,
            [name]: value
        }));
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     setIsLoading(true);
        
    //     try {
    //         await auth.login(credentials, rememberMe);
    //         toast.success("Login successful!");
    //         navigate("/dashboard");
    //     } catch (error) {
    //         toast.error(error.message || "Login failed. Please try again.");
    //         setIsLoading(false);
    //     }
    // };


      const handleSubmit = (e) => {
        e.preventDefault();
        setIsLoading(true);
        AccountsService.userLogin({
          userName: credentials.username,
          password: credentials.password,
        })
          .then((res) => {
            console.log(res);
            if (res.status === 200) {
              localStorage.setItem("user", res.data.data.accessToken);
              auth.login();
              navigate("/welcome");
              toast.success("Login Successfull");
            }
          })
          .catch((err) => {
            toast.error(toTitleCase(err?.response?.data?.errMessage));
          });
        setIsLoading(false);
      };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="login-page"
        >
            <Container className="login-container">
                <Row className="justify-content-center align-items-center min-vh-100">
                    <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                        <motion.div
                            className="login-card"
                            initial={{ y: 20, opacity: 0 }}
                            animate={{ y: 0, opacity: 1 }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                        >
                            {/* Logo/Header Section */}
                            <motion.div 
                                className="login-header"
                                initial={{ scale: 0.9 }}
                                animate={{ scale: 1 }}
                                transition={{ delay: 0.2 }}
                            >
                                <div className="login-logo">
                                    <img 
                                        src="https://cdn3d.iconscout.com/3d/premium/thumb/man-avatar-6299539-5187871.png" 
                                        alt="App Logo" 
                                    />
                                </div>
                                <h2>Welcome Back</h2>
                                <p>Please Enter Your Credentials To Login</p>
                            </motion.div>

                            {/* Login Form */}
                            <Form onSubmit={handleSubmit}>
                                <motion.div
                                    initial={{ opacity: 0, y: 10 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: 0.3 }}
                                >
                                    <Form.Group className="mb-3" controlId="username">
                                        <Form.Label>Username</Form.Label>
                                        <div className="input-group">
                                            {/* <span className="input-icon">
                                                <i className="fas fa-user"></i>
                                            </span> */}
                                            <Form.Control
                                                type="text"
                                                name="username"
                                                value={credentials.username}
                                                onChange={handleChange}
                                                placeholder="Enter Your Username"
                                                required
                                            />
                                        </div>
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="password">
                                        <Form.Label>Password</Form.Label>
                                        <div className="input-group">
                                            {/* <span className="input-icon">
                                                <i className="fas fa-lock"></i>
                                            </span> */}
                                            <Form.Control
                                                type={showPassword ? "text" : "password"}
                                                name="password"
                                                value={credentials.password}
                                                onChange={handleChange}
                                                placeholder="Enter Your Password"
                                                required
                                            />
                                            <button 
                                                type="button" 
                                                className="password-toggle"
                                                onClick={togglePasswordVisibility}
                                            >
                                                <i className={`fas ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                            </button>
                                        </div>
                                    </Form.Group>

                                    <motion.div
                                        whileHover={{ scale: 1.02 }}
                                        whileTap={{ scale: 0.98 }}
                                    >
                                        <Button 
                                            variant="primary" 
                                            type="submit" 
                                            className="w-100 login-button"
                                            disabled={isLoading}
                                        >
                                            {isLoading ? (
                                                <>
                                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                    Logging in...
                                                </>
                                            ) : (
                                                'Login'
                                            )}
                                        </Button>
                                    </motion.div>
                                </motion.div>
                            </Form>
                        </motion.div>
                    </Col>
                </Row>
            </Container>
        </motion.div>
    );
};

export default IntroducerLogin;